export function quintileClass(value) {
    if (!value) {
        return 'score-none';
    }
    if (value > 0 && value < 1) {
        value = 100 * value;
    }
    if (value <= 20) {
        return 'score-low';
    } else if (value <= 40) {
        return 'score-below-avg';
    } else if (value <= 60) {
        return 'score-avg';
    } else if (value <= 80) {
        return 'score-above-avg';
    } else {
        return 'score-high';
    }
}

export default {
    quintileClass,
};
